export default __webpack_public_path__ + "static/media/placeholderImg.svg.4d1dba3d.png";